export default {
  computed: {
    viewerModule() {
      return this.$store.getters['currentProject/viewerModulePath'];
    },
    imageModule() {
      return this.$store.getters['currentProject/imageModulePath'](this.index);
    },
    viewerWrapper() {
      return this.$store.getters['currentProject/currentViewer'];
    },
    imageWrapper() {
      return this.viewerWrapper.images[this.index];
    },
    image() {
      return this.imageWrapper.imageInstance;
    },
    activeSlices() {
      return this.imageWrapper.activeSlices;
    },
    isActiveImage() {
      return this.viewerWrapper.activeImage === this.index;
    },
  }
};
